import { render, staticRenderFns } from "./activeMobile.vue?vue&type=template&id=258f3493&scoped=true"
import script from "./activeMobile.vue?vue&type=script&lang=js"
export * from "./activeMobile.vue?vue&type=script&lang=js"
import style0 from "./activeMobile.vue?vue&type=style&index=0&id=258f3493&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f3493",
  null
  
)

export default component.exports